export default "__VITE_ASSET__CR_2QYEc__"